'use client';
import classNames from 'classnames/bind';
import React from 'react';

import { Button } from '@components/Button/Button';
import { Icon } from '@components/Icon/Icon';
import { Text } from '@components/Text/Text';

import styles from './FeatureItem.module.scss';
import AngleDownIcon from '@icons/angleDown.svg';

export interface IFeatureItem {
  icon: JSX.Element;
  title: string;
  description: string;
  href?: string;
}
interface IProps extends IFeatureItem {
  isOpen: boolean;
  onToggle: () => void;
}

const cx = classNames.bind(styles);

export const FeatureItem: React.FC<IProps> = ({
  icon,
  title,
  description,
  href,
  isOpen,
  onToggle,
}) => (
  <div className={cx('item', { isOpen })}>
    <button className={styles.button} onClick={onToggle}>
      <div className={styles.buttonWrapper}>
        <div className={styles.contentWrapper}>
          <Icon className={styles.icon} size={22}>
            {icon}
          </Icon>
          <Text color="gray800" size={16} tag="strong" weight="regular">
            {title}
          </Text>
        </div>
        <span className={styles.arrowIconWrapper}>
          <AngleDownIcon className={styles.arrowIcon} />
        </span>
      </div>
    </button>
    {isOpen && (
      <div className={styles.openContent}>
        <div className={styles.description}>{description}</div>
        <div className="mb-5">
          {href && (
            <Button href={href} testId="button" withArrow>
              Learn more
            </Button>
          )}
        </div>
      </div>
    )}
  </div>
);
